import PropTypes from "prop-types";
import { Children, cloneElement } from "react";
import { Card, Text } from "@/base";
import FlexCard from "./FlexCard";

export function ColumnGroup({ children, fullWidth }) {

  const columnCount = Children.count(children.filter(x => x !== null));

  let items = Children.map(children, (child, childIndex) => {
    return child ? cloneElement(child, { columnCount,childIndex }) : null;
  })

  return fullWidth ? (
      <div className={'d-flex flex-row flex-wrap'}>
        {items}
      </div>
  ) : (
      <div className={'container'}>
        <div className={'row'}>
          {items}
        </div>
    </div>
  );
}

ColumnGroup.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool
};

const _getFirstValidCardEntity = (column) => {
  let firstValidEntity = null;

  const validCardTypes = [
    "flex_card",
    "card",
    "flag_pane_card",
    "flag_pane_header_card",
    "flag_pane_video_modal_card",
    "flag_pane_form_modal_card",
  ];

  for (const entity in column) {

    if (validCardTypes.includes(entity)) {
      firstValidEntity = Array.isArray(column[entity])
        ? column[entity][0]
        : column[entity];
      entity === 'flag_pane_video_modal_card' ? firstValidEntity.isVideo = true : firstValidEntity.isVideo = false;
      entity === 'flex_card' ? firstValidEntity.flexCard = true : firstValidEntity.flexCard = false;
      break;
    }
  }

  /* eslint-disable */
  return firstValidEntity;
};

export function Column({ column, columnCount, stylesOverride, childIndex, original }) {

  if (Object.keys(column).length === 0) return null; // Sanity check

  /*
    Rule: Only one card per column.
    Get the first valid entity, and use that build the <Card/>
  */
  const entity = _getFirstValidCardEntity(column);

  if(entity.flexCard) {
    let flexElements = original?.value?.elements.find((el)=>el.render_name==='flex_card') || [];
    return <FlexCard entity={entity} columnCount={columnCount} childIndex={childIndex} original={flexElements}/>
  }

  // OLD CARD OPTIONS...

  const kicker = entity.kicker || entity.header;

  const colClass = () => {
    if(childIndex !== 2){
      return `size-full size-ns-1of2 size-lg-1of${columnCount} columns--${columnCount} pb-2.5`
    } else {
      return `size-full size-lg-1of${columnCount} columns--${columnCount} pb-2.5`
    }
  }

  return entity && (
    <div css={[stylesOverride]} className={colClass()}
         data-aos={"fade-up"} data-aos-delay={500 + (200*childIndex)} data-aos-duration={1000}>
      <Card
        kicker={kicker ? kicker.value : null}
        text={entity.text ? entity.text.value : null}
        buttonTheme={entity.call_to_action?.button_theme?.value ? entity.call_to_action.button_theme.value : null}
        ctaUrl={entity.call_to_action ? entity.call_to_action.button_url.value : null}
        ctaText={entity.call_to_action ? entity.call_to_action.button_text.value : null}
        imageUrl={entity.image ? entity.image.image_url.value : null}
        imageAlt={entity.image ? entity.image.alt_text.value : null}
        iconUrl={entity.icon ? entity.icon.image_url.value : null}
        iconCaption={entity.caption ? entity.caption.value : null}
        isVideo={entity.isVideo}
        videoId={entity.video ? entity.video.video_id.value : null}
        videoProvider={entity.video ? entity.video.video_provider.value : null}
      >
        <Text>
          <span dangerouslySetInnerHTML={{ __html: entity.text.value }} />
        </Text>
      </Card>
    </div>
  );
}

Column.defaultProps = {
  columnCount: 1,
  stylesOverride: {}
};

Column.propTypes = {
  column: PropTypes.object,
  columnCount: PropTypes.number,
  stylesOverride: PropTypes.object
};
